/**
 * If these are reusable, please feel free to move them to a shared location.
 */
export const SvgPrevCaret = () => (
  <svg
    viewBox={`0 0 12 12`}
    className={`text-default absolute bottom-[10px] left-1 rotate-90 stroke-[1.5px]`}
    tabIndex="-1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <polyline
      className="cls-1"
      points="0.28 0.55 5.82 6.77 11.35 0.24"
    ></polyline>
  </svg>
);

export const SvgNextCaret = () => (
  <svg
    viewBox={`0 0 12 12`}
    className={`text-default absolute right-[7px] bottom-[10px] -rotate-90 stroke-[1.5px]`}
    tabIndex="-1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <polyline
      className="cls-1"
      points="0.28 0.55 5.82 6.77 11.35 0.24"
    ></polyline>
  </svg>
);

//video player icons
export const SvgPlay = ({ handlePlay, classes }) => (
  <div
    className={`z-60 mx-auto my-auto h-45 w-45 cursor-pointer ${classes}`}
    onClick={handlePlay}
  >
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 24 24"
      xmlSpace="preserve"
      aria-label="play video"
    >
      <path
        className="st0"
        d="M21,12c0-5-4-9-9-9c-5,0-9,4-9,9c0,5,4,9,9,9C17,21,21,17,21,12z"
        style={{
          fill: 'none',
          stroke: '#FFFFFF',
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        }}
      />
      <path
        id="Vector_2"
        className="st1"
        d="M9.5,8v8l6.7-4L9.5,8z"
        style={{ fill: '#FFFFFF' }}
      />
    </svg>
  </div>
);

export const SvgPause = ({ handlePause, classes }) => (
  <div
    className={`z-60 mx-auto my-auto hidden h-45 w-45 cursor-pointer ${classes} ${classes?.includes('group-hover') ? '' : 'group-hover:block'}`}
    onClick={handlePause}
  >
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 24 24"
      xmlSpace="preserve"
      aria-label="pause video"
    >
      <path
        className="st0"
        d="M21,12c0-5-4-9-9-9c-5,0-9,4-9,9c0,5,4,9,9,9C17,21,21,17,21,12z"
        style={{
          fill: 'none',
          stroke: '#FFFFFF',
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        }}
      />
      <path className="st1" d="M9,8h2v8H9V8z" style={{ fill: '#FFFFFF' }} />
      <path className="st1" d="M13,8h2v8h-2V8z" style={{ fill: '#FFFFFF' }} />
    </svg>
  </div>
);

export const MobileSvgPlay = ({ handlePlay, classes }) => (
  <div
    className={`absolute right-6 bottom-3.75 z-60 h-12.5 w-12.5 cursor-pointer ${classes}`}
    onClick={handlePlay}
  >
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 24 24"
      xmlSpace="preserve"
    >
      <path
        id="Vector"
        className="st0"
        d="M21,12c0-5-4-9-9-9c-5,0-9,4-9,9c0,5,4,9,9,9C17,21,21,17,21,12z"
        style={{
          fill: 'none',
          stroke: '#FFFFFF',
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        }}
      />
      <path
        id="Vector_2"
        className="st1"
        d="M9.5,8v8l6.7-4L9.5,8z"
        style={{ fill: '#FFFFFF' }}
      />
    </svg>
  </div>
);

export const MobileSvgPause = ({ handlePause, classes }) => (
  <div
    className={`classes absolute right-6 bottom-3.75 h-12.5 w-12.5 cursor-pointer ${classes}`}
    onClick={handlePause}
  >
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 24 24"
      xmlSpace="preserve"
    >
      <path
        className="st0"
        d="M21,12c0-5-4-9-9-9c-5,0-9,4-9,9c0,5,4,9,9,9C17,21,21,17,21,12z"
        style={{
          fill: 'none',
          stroke: '#FFFFFF',
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        }}
      />
      <path className="st1" d="M9,8h2v8H9V8z" style={{ fill: '#FFFFFF' }} />
      <path className="st1" d="M13,8h2v8h-2V8z" style={{ fill: '#FFFFFF' }} />
    </svg>
  </div>
);

export const ThumbnailSvgPlay = () => (
  <div className="mx-auto my-auto h-[50px] w-[50px] cursor-pointer">
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="-1 -1 26 26"
      xmlSpace="preserve"
    >
      <path
        id="Vector"
        className="st0"
        d="M21,12c0-5-4-9-9-9c-5,0-9,4-9,9c0,5,4,9,9,9C17,21,21,17,21,12z"
        style={{
          fill: 'none',
          stroke: '#FFFFFF',
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        }}
      />
      <path
        id="Vector_2"
        className="st1"
        d="M9.5,8v8l6.7-4L9.5,8z"
        style={{ fill: '#FFFFFF' }}
      />
    </svg>
  </div>
);

// Checkbox Icons
export const SvgCheckbox = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
    >
      <path
        d="M7.33337 12.6745L11.8334 17.1745L19.3334 8.17451"
        stroke="#9BFF9B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.83337 0.674515C2.00495 0.674515 1.33337 1.34609 1.33337 2.17451V23.1745C1.33337 24.0029 2.00495 24.6745 2.83337 24.6745H23.8334C24.6618 24.6745 25.3334 24.0029 25.3334 23.1745V2.17451C25.3334 1.34609 24.6618 0.674515 23.8334 0.674515H2.83337Z"
        stroke="#9BFF9B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SvgEmptyCheckbox = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
    >
      <path
        d="M2.83331 0.6745C2.00489 0.6745 1.33331 1.34607 1.33331 2.1745V23.1745C1.33331 24.0029 2.00489 24.6745 2.83331 24.6745H23.8333C24.6617 24.6745 25.3333 24.0029 25.3333 23.1745V2.1745C25.3333 1.34607 24.6617 0.6745 23.8333 0.6745H2.83331Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SvgCheck = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="inline-block min-h-4 min-w-4"
  >
    <g>
      <path
        d="M3.33325 7.99996L6.44436 11.3333L12.6666 4.66663"
        stroke="#9BFF9B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const SvgCrossedCheckbox = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
    >
      <path
        d="M2.83337 0.6745C2.00495 0.6745 1.33337 1.34607 1.33337 2.1745V23.1745C1.33337 24.0029 2.00495 24.6745 2.83337 24.6745H23.8334C24.6618 24.6745 25.3334 24.0029 25.3334 23.1745V2.1745C25.3334 1.34607 24.6618 0.6745 23.8334 0.6745H2.83337Z"
        fill="white"
        fillOpacity="0.2"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line x1="1.85351" y1="1.3209" x2="24.8372" y2="24.2991" stroke="white" />
    </svg>
  );
};
